import { Chip, Grid, Box, Typography, Badge, Divider } from "@mzc-pdc/ui";
import { IconArrowDropDown } from "@mzc-cloudplex/icons";
import { useTranslation } from "react-i18next";
import { alpha } from "@mui/material";
import theme from "@styles/theme";

const BaseFilterChip = ({ item, onClick, onDelete, styleOverrides, selected }) => {
    const { t } = useTranslation();

    // styleOverrides 미전달 → 기본(essential) 스타일, 전달 → 객체 값으로 오버라이드
    const active = styleOverrides?.active ?? !!item.value;
    const titleColor = styleOverrides?.titleColor ?? (item.label ? "primary" : theme.palette.greySecondary.main);
    const arrowColor = styleOverrides?.arrowColor ?? theme.palette.greySecondary[500];
    const badgeSx = styleOverrides?.badgeSx;

    return (
        <Chip
            active={active}
            sx={
                selected
                    ? {
                          backgroundColor: active
                              ? alpha(theme.palette.greySecondary.A100, 0.8)
                              : alpha(theme.palette.greySecondary.main, 0.08),
                      }
                    : undefined
            }
            label={
                <Grid alignItems="center" container gap={1}>
                    <Typography color={titleColor} variant="body3_400">
                        {t(`common::label::${item.title}`, item.title)}
                    </Typography>
                    <Typography>{item.label ? t(`common::label::${item.label}`, item.label) : ""}</Typography>
                    {item.length > 0 && (
                        <Box sx={badgeSx}>
                            <Badge badgeContent={<>+{item.length}</>} color="primary" />
                        </Box>
                    )}
                    <Box>
                        <IconArrowDropDown size={20} color={arrowColor} />
                    </Box>
                    {onDelete && <Divider flexItem orientation="vertical" />}
                </Grid>
            }
            onClick={onClick}
            onDelete={onDelete}
            size="medium"
            variant="filter"
        />
    );
};

export default BaseFilterChip;
